

// @flow
import * as React from 'react';

/**
 * Search svg
 *
 * @param props
 * @return {XML}
 */
export default ({ color }) => {

    return (
        <svg style={{ color: 'red', fill: 'red' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="none" fillRule="nonzero" stroke="#000" strokeWidth="2" d="M18.987 17.977L13.53 12.52l.495-.69a6.706 6.706 0 0 0 1.267-3.925C15.29 4.098 12.098 1 8.145 1S1 4.098 1 7.904s3.192 6.904 7.145 6.904a7.26 7.26 0 0 0 4.663-1.673l.702-.584 5.452 5.452.025-.026z"/>
        </svg>
    );

}